import React, { useRef } from 'react';
import { toCardPoint, clamp, CARD_W, CARD_H } from '../spriteEngine';
import './DraggableSprite.css';

const DraggableSprite = ({ sprite, src, label, selected, editable, onSelect, onChange, onDelete }) => {
  const wrapRef = useRef(null);
  const drag = useRef(null);

  const getCardEl = () => wrapRef.current?.closest('.card-art-layer');

  const onPointerDownMove = (e) => {
    if (!editable) return;
    e.preventDefault();
    e.stopPropagation();
    onSelect(sprite.id);
    const cardEl = getCardEl();
    if (!cardEl) return;
    const p = toCardPoint(cardEl, e.clientX, e.clientY);
    drag.current = { startPointer: p, startX: sprite.x, startY: sprite.y };
    e.currentTarget.setPointerCapture(e.pointerId);
  };

  const onPointerMove = (e) => {
    if (!drag.current) return;
    const cardEl = getCardEl();
    if (!cardEl) return;
    const p = toCardPoint(cardEl, e.clientX, e.clientY);
    const d = drag.current;
    const dx = p.x - d.startPointer.x;
    const dy = p.y - d.startPointer.y;
    onChange(sprite.id, {
      x: clamp(d.startX + dx, 0, CARD_W),
      y: clamp(d.startY + dy, 0, CARD_H),
    });
  };

  const onPointerUp = () => { drag.current = null; };

  return (
    <div
      ref={wrapRef}
      data-sprite-id={sprite.id}
      className={`sprite-instance${selected ? ' selected' : ''}${editable ? ' editable' : ''}${sprite.kind === 'pokemon' ? ' pixel-sprite' : ''}`}
      style={{
        left: 0, top: 0,
        width: sprite.w, height: sprite.h,
        transform: `translate(${sprite.x - sprite.w / 2}px, ${sprite.y - sprite.h / 2}px)`,
        zIndex: sprite.z,
      }}
      onPointerDown={editable ? onPointerDownMove : undefined}
      onPointerMove={editable ? onPointerMove : undefined}
      onPointerUp={editable ? onPointerUp : undefined}
      onPointerCancel={editable ? onPointerUp : undefined}
    >
      <img
        src={src}
        alt={sprite.name}
        draggable={false}
        className="sprite-instance-img"
        style={{ transform: sprite.flip ? 'scaleX(-1)' : 'none' }}
      />
      {label && <div className="sprite-placeholder-label">{label}</div>}
      {editable && selected && (
        <>
          <button
            type="button"
            className="sprite-ctrl sprite-delete"
            onPointerDown={e => e.stopPropagation()}
            onClick={(e) => { e.stopPropagation(); onDelete(sprite.id); }}
            title="Delete"
          >✕</button>
          <button
            type="button"
            className="sprite-ctrl sprite-flip"
            onPointerDown={e => e.stopPropagation()}
            onClick={(e) => { e.stopPropagation(); onChange(sprite.id, { flip: !sprite.flip }); }}
            title="Flip"
          >⇋</button>
        </>
      )}
    </div>
  );
};

export default DraggableSprite;
